import { NewChip } from "@/components/common/new-chip";
import {
  PeriodChip,
  TypeChip,
  YearChip,
} from "@/components/common/report-chip";
import { cn } from "@/lib/utils";
import { Fragment } from "react";
import { ParsedDsdMeta } from "./parse-dsd-filename";

/** 카드 하단에 표시할 메타(기존 보고서 비교용 — 업로드일/버전 등) */
export interface FileSummaryInfo {
  label: string;
  value: string;
}

interface FileSummaryCardProps {
  /** 유형·연도·기간 칩 */
  meta: ParsedDsdMeta;
  /** 파일명 또는 기존 보고서 이름 */
  title: string;
  /** 우상단 New 뱃지(신규 업로드 파일) */
  isNew?: boolean;
  /** 있으면 하단에 메타(버전/업로드일)를 한 줄로 노출 */
  info?: FileSummaryInfo[];
  className?: string;
}

// ============================================
// FileSummaryCard
// 회색 컨테이너 안에 놓이는 흰색 보고서 요약 카드.
// 신규 파일(New)과 기존 보고서(버전·업로드일) 양쪽에 쓰인다.
// ============================================

export const FileSummaryCard = ({
  meta,
  title,
  isNew,
  info,
  className,
}: FileSummaryCardProps) => (
  <div className={cn("flex flex-col gap-2 rounded-lg bg-white p-3", className)}>
    <div className="flex items-center justify-between gap-2">
      <div className="flex items-center gap-1">
        {meta.type && <TypeChip type={meta.type} size="large" />}
        {meta.year && <YearChip year={meta.year} size="large" />}
        {meta.period && <PeriodChip period={meta.period} size="large" />}
      </div>
      {isNew && <NewChip color="red" size="large" />}
    </div>
    <p className="line-clamp-2 break-all label-1-normal-medium text-label-normal">
      {title}
    </p>

    {info && info.length > 0 && (
      <div className="flex items-center gap-2 caption-1-regular text-label-alternative">
        {info.map((row, i) => (
          <Fragment key={row.label}>
            {i > 0 && <span className="h-3 w-px bg-line-normal" />}
            <span>
              {row.label}: {row.value}
            </span>
          </Fragment>
        ))}
      </div>
    )}
  </div>
);
